<template>
  <div class="invoiceDetails">

    <customModal v-if="modalData" v-show="modalData" :onModalClose="onModalClose" :onModalAccept="changeCurrency"
                 :modalData="modalData" validate="cityCurrency">
      <div slot-scope="slotProps">
        <currencySelect :drug="modalData.drug" :updateCurrency="slotProps.updateCurrency"
                        :updateModalData="slotProps.updateModalData"/>
      </div>
    </customModal>

    <table class="table table-sm">
      <thead>
      <tr>
        <th width="50">№</th>
        <th v-if="useCurrency" class="wrap" width="50">Другая валюта</th>
        <th class="drug_field">Препарат</th>
        <th>Количество</th>
        <th v-if="invoiceType == 'income'">Стоимость</th>
        <th v-if="invoiceType == 'income'">Сумма</th>
        <th v-if="invoiceType == 'income'">Скидка</th>
        <th v-if="invoiceType !== 'income'">Себестоимость</th>
        <th v-if="invoiceType == 'transit' || invoiceType == 'writeOff'">Наличие</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(drug, index) in drugList" :key="index">
        <td>{{ index + 1 }}</td>
        <td v-if="useCurrency">
          <div class="flex v-align-center">
            <input @change="clearDrug(drug.drug ? drug.drug.id : null)" v-model="drug.anotherCurrency" type="checkbox">
            <button @click="changingCurrency(drug)"
                    v-if="drug.drug && drug.anotherCurrency && drug.drug.income_currency_id !== invoice.currency_alias"
                    class="btn btn-primary btn-xs m-l-5 small_padding">сменить
            </button>
          </div>
        </td>
        <td>
          <DrugSearchNew
            :ref="`search_drug_${index}`"
            :selectedDrug="drug.drug"
            :onSelect="(d) => addDrug(index, d)"
            :storeIdRequest="invoice.store_out"
            :searchOptions="invoiceType === 'writeOff' ? null : {lastIncomeInvoice: true, currencyId: invoiceType === 'income' ? (!drug.anotherCurrency ? invoice.currency_id : false) : false}"
          />
          <div class="drug_info_block">
            <p v-if="drug.drug && drug.drug.pack_set && +drug.drug.pack_set !== 1">Препарат комплектный: <span
              class="badge badge-info">1 комплект</span> - <strong>{{ drug.drug.pack_set }}</strong> (зав.уп.)</p>
            <p v-if="drug.drug && drug.drug.cool"><span class="icon icon-snowflake"></span> необходим хладоген</p>
            <p class="pack_comment" v-if="drug.drug && drug.drug.pack_comment">{{ drug.drug.pack_comment }}</p>
            <p class="pack_box_comment" v-if="drug.drug && drug.drug.pack_box_comment">
              {{ drug.drug.pack_box_comment }}</p>
          </div>
        </td>
        <td class="vtop">
          <div v-if="drug.drug">
            <input @change="updateDiscountData" type="number" class="form-control" :name="`req_qty_${drug.drug.id}`"
                   placeholder="Кол. упаковок"
                   v-validate="'required|decimal'"
                   data-vv-as="Кол. упаковок"
                   v-model="drug.drug.qty">
            <small class="form-text text-danger"
                   v-if="errors.has(`req_qty_${drug.drug.id}`)">
              {{ errors.first(`req_qty_${drug.drug.id}`) }}
            </small>
            <p v-if="drug.drug.pack_set && drug.drug.pack_set != 1">зав.уп.</p>
          </div>
        </td>
        <td class="vtop" v-if="invoiceType == 'income'">
          <div v-if="drug.drug">
            <input @change="updateDiscountData" type="number" class="form-control" :name="`req_price_${drug.drug.id}`"
                   placeholder="Стоимость"
                   v-validate="'required|decimal'"
                   data-vv-as="Стоимость"
                   v-model="drug.drug.price">
            <small class="form-text text-danger"
                   v-if="errors.has(`req_price_${drug.drug.id}`)">
              {{ errors.first(`req_price_${drug.drug.id}`) }}
            </small>
          </div>
        </td>
        <td class="vtop" v-if="invoiceType == 'income'"><span v-if="drug.drug">{{ printSumm(drug.drug) }}</span></td>
        <td class="vtop" v-if="invoiceType == 'income'">
          <div class="discount_div" v-html="printDiscount(drug.drug)"></div>
        </td>
        <td class="mid_right" v-if="invoiceType !== 'income'">
          <template v-if="drug && drug.drug && loadingCostPrice[drug.drug.id]">
            <clip-loader
              :loading="true"
              :color="$constants.LOADING_COLOR"
              size="20px"
            />
          </template>
          <template v-else>
            {{ drug.drug && costPriceData[drug.drug.id] }}
          </template>
        </td>
        <td class="mid_right" v-if="invoiceType == 'transit' || invoiceType == 'writeOff'">
          <template v-if="drug && drug.drug">
            {{ storeData && storeData[drug.drug.id] || drug.drug.in_store && drug.drug.in_store.qty || '00' }}
          </template>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

import api from '@/api'
import vSelect from 'vue-select';
import * as _ from 'lodash';
import customModal from '@/components/modals/customModal'
import currencySelect from '@/components/currencySelect'
import DrugSearchNew from '@/components/drugs/DrugSearchNew'


export default {
  components: {
    vSelect,
    customModal,
    currencySelect,
    DrugSearchNew,
  },
  props: [
    'invoice', 'updateDiscount', 'useCurrency', 'invoiceType', 'storeId', 'storeData'
  ],
  data() {
    return {
      modalData: null,
      defaultDrugList: [],
      drugList: [],
      loadingCostPrice: {},
      costPriceData: {},
      Toast: this.$swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000
      }),
    }
  },
  mounted() {
    // if (this.invoiceType === 'income') {
    // this.getDrugList();
    // } else {
    this.addEmptyRow();
    // }
  },
  computed: {
    $AllCurrencies() {
      return this.$store.getters['platform/currencies']
    },
  },
  methods: {
    async getCostPrice(drug) {
      this.loadingCostPrice[drug.id] = true;
      this.loadingCostPrice = {...this.loadingCostPrice};
      const {data} = await api.post('/new/drugs/infoType', {
        drug_id: drug.id,
        types: ['costPrice']
      })
      if (data.success) {
        this.costPriceData[drug.id] = data.cost_price;
        this.costPriceData = {...this.costPriceData}
        // const index = this.drugList.findIndex((d) => d.drug && d.drug.id === drug.id);
        // if (index !== -1) {
        //   this.drugList[index].
        // }
      }
      this.loadingCostPrice[drug.id] = false;
    },
    updateDrugDiscount(drugs) {
      drugs.forEach((d) => {
        if (d.drug) {
          this.drugList.map((dl) => {
            if (dl.id == d.drug.id) {
              dl.clearedDiscountPrice = d.drug.clearedDiscountPrice;
              dl.discount_price = d.drug.discount_price;
            }
          })
        }
      });
      this.drugList = [...this.drugList];
    },
    updateDiscountData() {
      console.log('updating discount ....');
      if (this.invoiceType === 'transit' || this.invoiceType == 'writeOff') {
        this.drugList.forEach((d) => {
          if (!d.drug) return;
          let inStore = d.drug.in_store && d.drug.in_store.qty || 0;
          if (d.drug.qty < 0) {
            d.drug.qty = 0;
            this.Toast.fire({
              type: 'warning',
              title: 'Количество препарата не может быть отрицательным'
            });
          }
          if (d.drug.qty > inStore) {
            d.drug.qty = inStore;
            this.Toast.fire({
              type: 'warning',
              title: 'Количество препарата не должно превышать наличие на складе'
            });
          }
        })
        this.drugList = [...this.drugList];
      }

      if (this.updateDiscount)
        this.updateDiscount(this.drugList);
    },
    async changeCurrency() {
      let {data} = await api.post('/drugs/updateCurrency', this.modalData);
      if (data.success) {
        this.Toast.fire({
          type: 'success',
          title: data.message || 'Обновлено'
        });
        this.onModalClose();
      } else {
        this.Toast.fire({
          type: 'warning',
          title: data.message || 'Ошибка'
        })
      }
    },
    onModalClose() {
      this.modalData = null;
    },
    async getDrugList() {
      let {data} = await api.post('/invoices/getDrugsByCurrency', {
        'currency': this.invoice.currency_alias
      });

      this.defaultDrugList = data.list;
      this.addEmptyRow();
    },
    clearDrug(drugId) {
      this.drugList = this.drugList.filter((d) => {
        if (d.drug && d.drug.id == drugId) {
          d.drug = null;
        }
        return d;
      });
    },
    printSumm(drug) {
      let sum = drug.qty * drug.price;
      return sum.toFixed(3);
    },
    printDiscount(drug) {
      if (!drug) return;
      if (!drug.discount_price) return;
      if (drug.price == 0) return;
      // if (!this.invoice.discount) return;
      // return drug;
      // console.log('print discount:', drug);
      let text = '';
      text += '<p>Стоимость: <strong>' + drug.discount_price + '</strong></p>';
      text += '<p>Общая: <strong>' + (+drug.discount_price * +drug.qty).toFixed(3) + '</strong></p>';
      text += '<p>округленная скидка: <strong>' + drug.clearedDiscountPrice + '</strong></p>';
      return text;
    },
    onSearchDrug(search, model) {
      // console.log(search, model);
      if (!search || search.length < 2) {
        model.searchLoading = false;
        return;
      }
      model.searchLoading = true;
      // loading(true);
      // this.search(loading, search, this, model);
      this.search(search, this, model);
    },
    // search: _.debounce((loading, search, vm, model) => {
    search: _.debounce((search, vm, model) => {

      let currency = model.anotherCurrency ? +model.anotherCurrency : 0;
      if (!vm.useCurrency) currency = 1;
      let url = `/api/noa/getDrugByName?search=${encodeURIComponent(search)}&currency=${vm.invoice.currency_alias}&anotherCurrency=${currency}`;
      if (vm.invoiceType === 'transit' || vm.invoiceType == 'writeOff') {
        url = `/api/noa/getDrugByName?search=${encodeURIComponent(search)}&currency=${vm.invoice.currency_alias}&anotherCurrency=1&storeId=${vm.storeId}`;
      }

      fetch(
        url
      ).then(res => {

        model.searchResult = false;

        res.json().then((json) => {
          let sorted = json.items.filter((el) => {
            let check = vm.drugList.filter((d) => {
              if (!d.drug) return false;
              return d.drug.id == el.id
            })
            if (check.length) return false;
            return true;
          });
          model.searchResult = sorted;
          vm.drugList = [...vm.drugList]
        });
        model.searchLoading = false;
      });
    }, 350),
    addDrug(index, drug) {
      if (!drug) {
        delete this.drugList[index];
        this.drugList = this.drugList.filter((d) => d)
        this.addEmptyRow();
        return;
      }
      const doubleCheck = this.drugList.find((d) => d && d.drug && d.drug.id === drug.id)
      if (doubleCheck) {
        toastr["warning"]("Препарат уже есть в списке2");
        const ref = `search_drug_${index}`
        this.$refs[ref][0].drug = null;
        return;
      }
      // console.log(drug);
      const oldDrugData = this.drugList[index];
      this.drugList[index] = {...oldDrugData, drug: {...drug, qty: 1}};
      let price;
      if (drug.lastIncomeInvoice) {
        price = drug.lastIncomeInvoice.income_price * this.$AllCurrencies[drug.lastIncomeInvoice.currency_id].rate;
        price = Math.round(price / this.$AllCurrencies[this.invoice.currency_id].rate * 100) / 100;
      } else {
        if (drug.projected_price) {
          price = Math.round(drug.projected_price / this.$AllCurrencies[this.invoice.currency_id].rate * 100) / 100;
        } else {
          price = 0;
        }
      }
      this.drugList[index].drug.price = price;
      this.drugList = [...this.drugList];
      if (!this.costPriceData[drug.id]) {
        this.getCostPrice(drug);
      }
      this.addEmptyRow();
    },
    selectDrug(e) {
      if (!e) {
        this.drugList = this.drugList.filter((dl) => dl.drug);
        this.addEmptyRow();
        return;
      }
      e = {drug: {...e}};
      this.drugList.map((d) => {
        if (d.drug && d.drug.id == e.id && !d.drug.price || d.drug && d.drug.id == e.id && e.currency != this.invoice.currency_alias) d.drug.price = 0;
      });

      e.qty = 1;
      this.addEmptyRow();
      this.updateDiscountData();
    },
    async changingCurrency(drug) {
      this.modalData = {
        drugId: drug.drug.id,
        drug: drug.drug,
        header: 'Смена валюты',
        body: 'Выберите валюту и страну для препарата<br><strong>' + drug.drug.title + '</strong>',
        acceptBtnText: 'Сохранить',
        cancelBtnText: 'Отмена'
      }
    },
    addEmptyRow() {
      let check = this.drugList.filter(d => d.drug == undefined);
      if (check.length == 0) this.drugList.push({});
    },
    getDefaultDrugList(drug) {
      let arr = this.defaultDrugList;
      if (drug.searchResult) {
        drug.searchResult.forEach((d) => {
          if (!d.currency) {
            d.currency = d.import_country.currency;
          }
        });
        return drug.searchResult;
      }
      if (drug.anotherCurrency && drug.anotherCurrency === true || !arr) {
        return [];
      }
      return arr.filter(opt => !this.drugList.some(d => d.drug && d.drug.id === opt.id));
    },
  }
}

</script>

<style>
.vs__search::placeholder {
  color: lightgray;
}

.discount_div p {
  margin-bottom: 3px;
}

.invoiceDetails .icon-snowflake {
  display: inline-block;
  width: 15px;
  height: 17px;
  background: #5BBFDE;
  margin: -3px 4px;
}

.invoiceDetails .drug_info_block p {
  margin-bottom: 2px;
}

.invoiceDetails .pack_comment {
  font-size: 12px;
  color: #3bb3d8;
}

.invoiceDetails .pack_box_comment {
  font-size: 12px;
  color: #6c757d;
}

.vs--single .vs__selected {
  max-width: 90%;
}
</style>

<style scoped>
.v-align-center {
  padding-top: 5px;
}

table.table td,
table.table th {
  padding: 3px;
  vertical-align: top;
}

.small_padding {
  padding: 1px 5px !important;
}

.wrap {
  white-space: normal;
}

.v-select .selected {
  font-size: 16px;
}

.drug_field {
  width: 550px;
}

.mid_right {
  text-align: right;
}
</style>
